import { getContext, setContext } from 'svelte';
const KEY = 'SERMON_DOWNLOAD_OPTIONS';
const DOWNLOAD_OPTIONS = [
    {
        label: 'as Text',
        icon: 'fa-solid fa-file',
        value: 'txt'
    },
    {
        label: 'as HTML',
        icon: 'fa-solid fa-file-code',
        value: 'html'
    },
    {
        label: 'as HTML (txt)',
        icon: 'fa-solid fa-file',
        value: 'html-txt'
    },
    {
        label: 'as PDF',
        icon: 'fa-solid fa-file-pdf',
        value: 'pdf'
    }
];
export const initDownloadOptionsContext = () => {
    setContext(KEY, DOWNLOAD_OPTIONS);
};
export const getDownloadOptionsContext = () => {
    return getContext(KEY);
};
